export enum ActionCallBack {
  SNACKBAR,
  NAVIGATION,
}
